import { useEvent } from 'hooks'
import { cn } from 'utils'

import { getDetailScopesSelector, getEditorComponents } from './selector'

export type DetailComponents = {
	actionPlannerDetailEditSwitcher?: HTMLInputElement
	actionPlannerDetailEditComponents?: NodeListOf<HTMLElement>
	actionPlannerDetailViewComponents?: NodeListOf<HTMLElement>
}

export const ActionPlanner = (() => {
	const switchVisibilityOfComponents = (visible: boolean, components?: NodeListOf<HTMLElement>) => {
		if (!components) {
			return
		}

		for (let i = 0; i < components.length; i++) {
			const component = components[i]
			if (!component) {
				continue
			}

			if (cn.hasClass(component, 'hidden') && visible) {
				cn.removeClass(component, 'hidden')
			}

			if (!cn.hasClass(component, 'hidden') && !visible) {
				cn.addClass(component, 'hidden')
			}
		}
	}

	const initActionPlannerDetailEdit = (detailEditorComponents: DetailComponents) => {
		const { actionPlannerDetailEditSwitcher, actionPlannerDetailViewComponents, actionPlannerDetailEditComponents } =
			detailEditorComponents

		if (!actionPlannerDetailEditSwitcher) {
			return
		}

		const click = useEvent(actionPlannerDetailEditSwitcher, 'click')

		click.register(() => {
			const isEditModeOn = actionPlannerDetailEditSwitcher.checked
			switchVisibilityOfComponents(!isEditModeOn, actionPlannerDetailViewComponents)
			switchVisibilityOfComponents(isEditModeOn, actionPlannerDetailEditComponents)
		})
	}

	const initDetail = () => {
		const details = getDetailScopesSelector()

		if (!details) {
			return
		}
		for (let i = 0; i < details.length; i++) {
			if (!details[i]) {
				continue
			}
			const editorComponents = getEditorComponents(details[i])
			initActionPlannerDetailEdit(editorComponents)
		}
	}

	const init = () => {
		initDetail()
	}

	return {
		init,
	}
})()
